import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import clsx from 'clsx';
import { useAccordion } from './AccordionWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AccordionHeader(_ref) {
  var children = _ref.children,
      hideArrow = _ref.hideArrow,
      description = _ref.description;

  var _useAccordion = useAccordion(),
      isExpanded = _useAccordion.isExpanded,
      setIsExpanded = _useAccordion.setIsExpanded;

  return /*#__PURE__*/_jsxs("div", {
    className: clsx('mb-[-1px] flex cursor-pointer items-center justify-between border-y px-10 py-6 text-xl transition-all first:rounded-t-xl first:border-t-0 hover:bg-gray-50', isExpanded ? 'bg-gray-50 hover:bg-white' : 'first:border-b-0'),
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    },
    children: [/*#__PURE__*/_jsxs("h2", {
      className: clsx('font-bold '),
      children: [children, description && /*#__PURE__*/_jsx("p", {
        className: "text-sm font-normal",
        children: description
      })]
    }), hideArrow ? null : /*#__PURE__*/_jsx(ExpandMoreIcon, {
      className: clsx('transition-transform', isExpanded ? 'rotate-180' : 'rotate-0')
    })]
  });
}